import { createUserUseCase } from '@src/main/modules/user/application/create-user.usecase';
import { CreateUpdateUserRequest } from '@src/main/modules/user/infrastructure/dto/createUpdateUserRequest';
import { createUserHttpRepository } from '@src/main/modules/user/infrastructure/UserHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateUser = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createUserHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateUpdateUserRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await createUserUseCase(data, tokenProvider);
    },
  });
};
